import { createContext, useContext, useState } from "react";

const ModalContext = createContext();

export const ModalProvider = ({ children }) => {
  const [activeModal, setActiveModal] = useState(null);
  const [emailForOtp, setEmailForOtp] = useState("");
  // NEW: Needed only for Register auto-login flow
  const [passwordForOtp, setPasswordForOtp] = useState("");


  return (
    <ModalContext.Provider value={{ activeModal, setActiveModal, emailForOtp, setEmailForOtp, passwordForOtp, setPasswordForOtp }}>
      {children}
    </ModalContext.Provider>
  );
};

export const useModal = () => useContext(ModalContext);
